import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {classMap} from 'lit/directives/class-map.js';
import {connect} from 'pwa-helpers';
import {when} from 'lit/directives/when.js';
import {msg} from '@lit/localize';
import store from '../../../store';

@customElement('light-new-specsheet')
export class LightNewSpecsheet extends connect(store)(LitElement) {

	static styles = [
		css`
			:host {
				container-type: inline-size;
			}

			@media screen {
				.page {
					max-width: 1400px;
					width: 90%;
					box-sizing: border-box;
					margin: 40px auto 20px auto;
					box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.25);
				}
			}
			@media print {
				.page {
					margin: 0;
					box-shadow: none;
				}
			}
		`
	];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.print = state.status.media === 'print' || status.media === 'print2';
		this.translations = state.productData.translations;
		this.profile = state.lightProfile.data.profile;
		this.lightProfile = state.lightProfile.data;
	}

	render() {
		return html`
			<shared-specsheet-page class="page ${classMap({print: this.print})}" title="${msg('Circular light profile')}" headLabel="${msg('Summary')}">
				<page-light-summary></page-light-summary>
			</shared-specsheet-page>
			<shared-specsheet-page class="page ${classMap({print: this.print})}" title="${msg('Circular light profile')}" headLabel="${msg('Annual chart')}">
				<page-light-profile></page-light-profile>
			</shared-specsheet-page>
			<shared-specsheet-page class="page ${classMap({print: this.print})}" title="${msg('Circular light profile')}"  headLabel="${msg('Light Profile')}">
				<page-tables date1="2024-01-15T00:00:00" date2="2024-03-15T00:00:00"></page-tables>
			</shared-specsheet-page>
			${when(this.lightProfile.project.luminary === null,
				() => html`
					<shared-specsheet-page class="page ${classMap({print: this.print})}" title="${msg('Circular light profile')}" headLabel="${msg('Luminaires')}">
						<page-luminare-all-available></page-luminare-all-available>
					</shared-specsheet-page>
				`,
				() => html`
					<shared-specsheet-page class="page ${classMap({print: this.print})}" title="${msg('Circular light profile')}" headLabel="${msg('Luminaire')}">
						<shared-technical-data-page></shared-technical-data-page>
					</shared-specsheet-page>
					<shared-specsheet-page class="page ${classMap({print: this.print})}" title="${msg('Circular light profile')}" headLabel="${msg('Luminaire')}">
						<shared-tender-text-page></shared-tender-text-page>
					</shared-specsheet-page>
				`
			)}
		`;
	}
}
